<template>
  <div class="vx-col w-full">
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-prompt title="Export To Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel"
          accept-text="Export" @close="clearFields" :active.sync="activePrompt">
          <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
          <v-select v-model="selectedFormat" :options="formats" class="my-4" />
          <div class="flex">
            <span class="mr-4">Cell Auto Width:</span>
            <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
          </div>
        </vs-prompt>

        <vx-card title="เลือกวันเวลา">
          <label>เริ่มต้น: </label>
          <flat-pickr :config="configdateTimePicker" v-model="before_datetime" placeholder="Date Time" />
          <br>
          <br>
          <label> สิ้นสุด: </label>
          <flat-pickr :config="configdateTimePicker" v-model="after_datetime" placeholder="Date Time" />
          <br>
          <br>
          <vs-button color="primary" @click="selectdate_time(currentWebsite)">ค้นหาในเว็บ {{ currentWebsite.label }}</vs-button>
          <vs-button class="ml-2" color="success" @click="selectdate_time({ label: 'เว็บไซต์ทั้งหมด', value: 'all' })">ค้นหาทุกเว็บไซต์</vs-button>
        </vx-card>

      </div>
    </div>

    <!-- promo-001 -->
    <vs-prompt class="export-options" @cancle="clearFields" @accept="exportToExcel(data[0], 'ฝาก 500 รับฟรีแก้วเยติเก๋ๆ 1 ใบ')"
      accept-text="Export" @close="clearFields" :active.sync="activePrompt001" title="ฝาก 500 รับฟรีแก้วเยติเก๋ๆ 1 ใบ">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>
    <!-- promo-002 -->
    <vs-prompt class="export-options" @cancle="clearFields" @accept="exportToExcel(data[1], 'ฝาก 1,000 รับฟรีเสื้อกีฬาสวย ๆ 1 ตัว')"
      accept-text="Export" @close="clearFields" :active.sync="activePrompt002" title="ฝาก 1,000 รับฟรีเสื้อกีฬาสวย ๆ 1 ตัว">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>
    <!-- promo-003 -->
    <vs-prompt class="export-options" @cancle="clearFields" @accept="exportToExcel(data[2], 'ฝาก 1,500 รับฟรีแก้ว TYESO ขนาด30oz 1 ใบ')"
      accept-text="Export" @close="clearFields" :active.sync="activePrompt003" title="ฝาก 1,500 รับฟรีแก้ว TYESO ขนาด30oz 1 ใบ">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>
    <!-- promo-004 -->
    <vs-prompt class="export-options" @cancle="clearFields"
      @accept="exportToExcel(data[3], 'ฝาก 1,500 รับฟรีชุดหูฟังบลูทูธ 1 ชุด')" accept-text="Export" @close="clearFields"
      :active.sync="activePrompt004" title="ฝาก 1,500 รับฟรีชุดหูฟังบลูทูธ 1 ชุด">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>
    <!-- promo-005 -->
    <vs-prompt class="export-options" @cancle="clearFields"
      @accept="exportToExcel(data[4], 'ฝาก 1,500 รับฟรีเตาปิ้งย่างไฟฟ้า 1 อัน')" accept-text="Export" @close="clearFields"
      :active.sync="activePrompt005" title="ฝาก 1,500 รับฟรีเตาปิ้งย่างไฟฟ้า 1 อัน">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

      <!-- promo-007 -->
      <vs-prompt class="export-options" @cancle="clearFields" @accept="exportToExcel(data[5], 'ฝาก 1,500 รับเก้าอี้แคปปิ้ง 1 อัน')"
      accept-text="Export" @close="clearFields" :active.sync="activePrompt006" title="ฝาก 1,500 รับเก้าอี้แคปปิ้ง 1 อัน">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <!-- promo-008 -->
    <vs-prompt class="export-options" @cancle="clearFields" @accept="exportToExcel(data[6], 'ฝาก 2,000 รับฟรีหมวก converse แท้ 1 ใบ')"
      accept-text="Export" @close="clearFields" :active.sync="activePrompt007" title="ฝาก 2,000 รับฟรีหมวก converse แท้ 1 ใบ">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <!-- promo-009 -->
    <vs-prompt class="export-options" @cancle="clearFields" @accept="exportToExcel(data[8], 'โปรโมชั่นฝากประจำวันวันพิเศษ')"
      accept-text="Export" @close="clearFields" :active.sync="activePromptSpecial" title="โปรโมชั่นฝากประจำวันวันพิเศษ">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <!-- promo-009 -->
    <vs-prompt class="export-options" @cancle="clearFields" @accept="exportToExcel(data[7], 'โปรโมชั่นฝากประจำวัน รับเพิ่ม 5%')"
      accept-text="Export" @close="clearFields" :active.sync="activePromptDaily" title="โปรโมชั่นฝากประจำวันวันพิเศษ">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <vs-prompt class="export-options" @cancle="clearFields" @accept="exportToExcel(data[9], 'โปรโมชั่น พิเศษ Happy Prime Time 7%')"
      accept-text="Export" @close="clearFields" :active.sync="activePromptWeekend" title="โปรโมชั่นฝากประจำวันวันพิเศษ">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <!-- affiliate -->
    <vs-prompt class="export-options" @cancle="clearFields" @accept="exportToExcel(data[10], 'แนะนำเพื่อน')"
      accept-text="Export" @close="clearFields" :active.sync="activePromptAffiliate" title="แนะนำเพื่อน">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <!-- turnpoint -->
    <vs-prompt class="export-options" @cancle="clearFields" @accept="exportToExcel(data[11], 'คืนยอดเล่น')"
      accept-text="Export" @close="clearFields" :active.sync="activePromptTurnpoint" title="คืนยอดเล่น">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <vs-prompt class="export-options" @cancle="clearFields" @accept="exportToExcel(data[12], 'ยอดฝากสะสมประจำเดือน')"
      accept-text="Export" @close="clearFields" :active.sync="activePromptTurnpoint" title="ยอดฝากสะสมประจำเดือน">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <!-- ranking -->
    <!-- <vs-prompt class="export-options" @cancle="clearFields" @accept="exportToExcel(data[11], 'ranking')"
      accept-text="Export" @close="clearFields" :active.sync="activePromptRanking" title="ranking">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt> -->

    <br>
    <vx-card>
      <p class="my-2" v-if="currentDataSource">แสดงข้อมูลจาก {{ currentDataSource }}</p>
      <vs-divider />

      <div class="vx-row">
        <div class="vx-col md:w-1/5 w-full">Type</div>
        <div class="vx-col md:w-1/5 w-full">Bonus</div>
        <div class="vx-col md:w-1/5 w-full">User</div>
        <div class="vx-col md:w-1/5 w-full">Credit</div>
        <div class="vx-col md:w-1/5 w-full"></div>
      </div>
      <br>
      <br>
      <div class="vx-row my-5">
        <!-- promo-001 -->
        <div class="vx-col md:w-1/5 w-full text-warning">ฝาก 500 รับฟรีแก้วเยติเก๋ๆ 1 ใบ</div>
        <div class="vx-col md:w-1/5 w-full text-warning">{{ rpbonus.Countsolonew01 }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full text-warning">{{ rpbonus.CountUsersolonew01 }} คน</div>
        <div class="vx-col md:w-1/5 w-full text-warning">{{ rpbonus.Sumsolonew01 }} Credit</div>
        <div class="vx-col md:w-1/5 w-full text-warning"><vs-button
            :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
            size="small"
            @click="activePrompt001 = true">Export</vs-button></div>
      </div>
      <div class="vx-row my-5">
        <!-- promo-002 -->
        <div class="vx-col md:w-1/5 w-full text-success">ฝาก 1,000 รับฟรีเสื้อกีฬาสวย ๆ 1 ตัว</div>
        <div class="vx-col md:w-1/5 w-full text-success">{{ rpbonus.Countsolonew02 }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full text-success">{{ rpbonus.CountUsersolonew02 }} คน</div>
        <div class="vx-col md:w-1/5 w-full text-success">{{ rpbonus.Sumsolonew02 }} Credit</div>
        <div class="vx-col md:w-1/5 w-full text-success"><vs-button
            :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
            size="small"
            @click="activePrompt002 = true">Export</vs-button></div>
      </div>
      <div class="vx-row my-5">
        <!-- promo-003 -->
        <div class="vx-col md:w-1/5 w-full text-danger">ฝาก 1,500 รับฟรีแก้ว TYESO ขนาด30oz 1 ใบ</div>
        <div class="vx-col md:w-1/5 w-full text-danger">{{ rpbonus.Countsolonew03 }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full text-danger">{{ rpbonus.CountUsersolonew03 }} คน</div>
        <div class="vx-col md:w-1/5 w-full text-danger">{{ rpbonus.Sumsolonew03 }} Credit</div>
        <div class="vx-col md:w-1/5 w-full text-danger"><vs-button
            :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
            size="small"
            @click="activePrompt003 = true">Export</vs-button></div>
      </div>
      <div class="vx-row my-5">
        <!-- promo-004 -->
        <div class="vx-col md:w-1/5 w-full text-warning">ฝาก 1,500 รับฟรีชุดหูฟังบลูทูธ 1 ชุด</div>
        <div class="vx-col md:w-1/5 w-full text-warning">{{ rpbonus.Countsolonew04 }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full text-warning">{{ rpbonus.CountUsersolonew04 }} คน</div>
        <div class="vx-col md:w-1/5 w-full text-warning">{{ rpbonus.Sumsolonew04 }} Credit</div>
        <div class="vx-col md:w-1/5 w-full text-warning"><vs-button
            :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
            size="small"
            @click="activePrompt004 = true">Export</vs-button></div>
      </div>

      <div class="vx-row my-5">
        <!-- promo-005 -->
        <div class="vx-col md:w-1/5 w-full text-success">ฝาก 1,500 รับฟรีเตาปิ้งย่างไฟฟ้า 1 อัน</div>
        <div class="vx-col md:w-1/5 w-full text-success">{{ rpbonus.Countsolonew05 }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full text-success">{{ rpbonus.CountUsersolonew05 }} คน</div>
        <div class="vx-col md:w-1/5 w-full text-success">{{ rpbonus.Sumsolonew05 }} Credit</div>
        <div class="vx-col md:w-1/5 w-full text-success"><vs-button
            :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
            size="small"
            @click="activePrompt005 = true">Export</vs-button></div>
      </div>

      <div class="vx-row my-5">
        <!-- promo-007 -->
        <div class="vx-col md:w-1/5 w-full text-danger">ฝาก 1,500 รับเก้าอี้แคปปิ้ง 1 อัน</div>
        <div class="vx-col md:w-1/5 w-full text-danger">{{ rpbonus.Countsolonew06 }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full text-danger">{{ rpbonus.CountUsersolonew06 }} คน</div>
        <div class="vx-col md:w-1/5 w-full text-danger">{{ rpbonus.Sumsolonew06 }} Credit</div>
        <div class="vx-col md:w-1/5 w-full text-danger"><vs-button
            :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
            size="small"
            @click="activePrompt006 = true">Export</vs-button></div>
      </div>

      <div class="vx-row my-5">
        <!-- promo-008 -->
        <div class="vx-col md:w-1/5 w-full text-warning">ฝาก 2,000 รับฟรีหมวก converse แท้ 1 ใบ</div>
        <div class="vx-col md:w-1/5 w-full text-warning">{{ rpbonus.Countsolonew07 }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full text-warning">{{ rpbonus.CountUsersolonew07 }} คน</div>
        <div class="vx-col md:w-1/5 w-full text-warning">{{ rpbonus.Sumsolonew07 }} Credit</div>
        <div class="vx-col md:w-1/5 w-full text-warning"><vs-button
            :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
            size="small"
            @click="activePrompt007 = true">Export</vs-button></div>
      </div>
      <vs-divider />
      <div class="vx-row my-5">
        <!-- promo-009 -->
        <div class="vx-col md:w-1/5 w-full">โปรโมชั่นฝากประจำวันวันพิเศษ</div>
        <div class="vx-col md:w-1/5 w-full">{{ rpbonus.Countsolospecial }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full">{{ rpbonus.CountUsersolospecial }} คน</div>
        <div class="vx-col md:w-1/5 w-full">{{ rpbonus.Sumsolospecial }} Credit</div>
        <div class="vx-col md:w-1/5 w-full text-warning"><vs-button
            :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
            size="small"
            @click="activePromptSpecial= true">Export</vs-button></div>
      </div>
      <div class="vx-row my-5">
        <!-- promo-009 -->
        <div class="vx-col md:w-1/5 w-full">โปรโมชั่นฝากประจำวัน รับเพิ่ม 5%</div>
        <div class="vx-col md:w-1/5 w-full">{{ rpbonus.Countsolodaily }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full">{{ rpbonus.CountUsersolodaily }} คน</div>
        <div class="vx-col md:w-1/5 w-full">{{ rpbonus.Sumsolodaily }} Credit</div>
        <div class="vx-col md:w-1/5 w-full text-warning"><vs-button
            :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
            size="small"
            @click="activePromptDaily = true">Export</vs-button></div>
      </div>
      <div class="vx-row my-5">
        <!-- promo-009 -->
        <div class="vx-col md:w-1/5 w-full">โปรโมชั่น พิเศษ Happy Prime Time 7%</div>
        <div class="vx-col md:w-1/5 w-full">{{ rpbonus.Countsoloweekend }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full">{{ rpbonus.CountUsersoloweekend }} คน</div>
        <div class="vx-col md:w-1/5 w-full">{{ rpbonus.Sumsoloweekend }} Credit</div>
        <div class="vx-col md:w-1/5 w-full text-warning"><vs-button
            :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
            size="small"
            @click="activePromptWeekend = true">Export</vs-button></div>
      </div>
     <vs-divider />
      <div class="vx-row my-5">
        <!-- affiliate -->
        <div class="vx-col md:w-1/5 w-full text-danger">แนะนำเพื่อน</div>
        <div class="vx-col md:w-1/5 w-full text-danger">{{ rpbonus.countaff }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full text-danger">{{ rpbonus.countuseraff }} คน</div>
        <div class="vx-col md:w-1/5 w-full text-danger">{{ rpbonus.sumaff }} Credit</div>
        <div class="vx-col md:w-1/5 w-full text-danger"><vs-button
            :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
            size="small"
            @click="activePromptAffiliate = true">Export</vs-button></div>
      </div>
      <div class="vx-row my-5">
        <!-- turnpoint -->
        <div class="vx-col md:w-1/5 w-full text-warning">คืนยอดเสีย</div>
        <div class="vx-col md:w-1/5 w-full text-warning">{{ rpbonus.countturn }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full text-warning">{{ rpbonus.countuserturn }} คน</div>
        <div class="vx-col md:w-1/5 w-full text-warning">{{ rpbonus.sumturn }} Credit</div>
        <div class="vx-col md:w-1/5 w-full text-warning"><vs-button
            :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
            size="small"
            @click="activePromptTurnpoint = true">Export</vs-button></div>
      </div>
      <vs-divider />
      <div class="vx-row my-5">
        <!-- turnpoint -->
        <div class="vx-col md:w-1/5 w-full text-primary">ยอดฝากสะสมประจำเดือน</div>
        <div class="vx-col md:w-1/5 w-full text-primary">{{ rpbonus.Countsolomonthly }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full text-primary">{{ rpbonus.CountUsersolomonthly }} คน</div>
        <div class="vx-col md:w-1/5 w-full text-primary">{{ rpbonus.Sumsolomonthly }} Credit</div>
        <div class="vx-col md:w-1/5 w-full text-primary"><vs-button
            :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
            size="small"
            @click="activePromptMonthly = true">Export</vs-button></div>
      </div>
      <!-- <div class="vx-row my-5"> -->
        <!-- ranking -->
        <!-- <div class="vx-col md:w-1/5 w-full text-success">ranking</div>
        <div class="vx-col md:w-1/5 w-full text-success">{{ rpbonus.countranking }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full text-success">{{ rpbonus.countuserranking }} คน</div>
        <div class="vx-col md:w-1/5 w-full text-success">{{ rpbonus.sumranking }} Credit</div>
        <div class="vx-col md:w-1/5 w-full text-warning"><vs-button
            :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
            size="small"
            @click="activePromptRanking = true">Export</vs-button></div>
      </div> -->

      <!-- <vs-divider />
      <div class="vx-row my-5"> -->
        <!-- card -->
        <!-- <div class="vx-col md:w-1/5 w-full text-success">เปิดการ์ดลุ้นโชค</div>
        <div class="vx-col md:w-1/5 w-full text-success">{{ rpbonus.countcard }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full text-success">{{ rpbonus.countusercard }} คน</div>
        <div class="vx-col md:w-1/5 w-full text-success">{{ rpbonus.sumcard }} Credit</div>
      </div> -->
      <!-- <div class="vx-row my-5"> -->
        <!-- spin -->
        <!-- <div class="vx-col md:w-1/5 w-full text-danger">เปิดกงล้อลุ้นโชค</div>
        <div class="vx-col md:w-1/5 w-full text-danger">{{ rpbonus.countspin }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full text-danger">{{ rpbonus.countuserspin }} คน</div>
        <div class="vx-col md:w-1/5 w-full text-danger">{{ rpbonus.sumspin }} Credit</div>
      </div> -->
      <!-- <div class="vx-row my-5"> -->
        <!-- card -->
        <!-- <div class="vx-col md:w-1/5 w-full text-warning">เครดิตฟรี</div>
        <div class="vx-col md:w-1/5 w-full text-warning">{{ rpbonus.countcreditfree }} ครั้ง</div>
        <div class="vx-col md:w-1/5 w-full text-warning">{{ rpbonus.countusercreditfree }} คน</div>
        <div class="vx-col md:w-1/5 w-full text-warning">{{ rpbonus.sumcreditfree }} Credit</div>
      </div> -->
      <br>
      <br>
    </vx-card>
  </div>
</template>

<script>
import axios from '../../../axios'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import vSelect from 'vue-select'


export default {
  components: {
    flatPickr,
    StatisticsCardLine,
    vSelect
  },
  data () {
    return {
      webname: process.env.VUE_APP_TITLE,
      before_datetime: moment.tz('Asia/Bangkok').format('YYYY-MM-DD 00:00'),
      after_datetime: moment.tz('Asia/Bangkok').add(1, 'days').format('YYYY-MM-DD HH:mm'),
      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        time_24hr: true
      },
      rpbonus: {},
      data: [],
      activePrompt: false,
      activePrompt001: false,
      activePrompt002: false,
      activePrompt003: false,
      activePrompt004: false,
      activePrompt005: false,
      activePrompt006: false,
      activePromptAffiliate: false,
      activePromptTurnpoint: false,
      activePromptMonthly:false,
      activePromptRanking: false,
      activePrompt007: false,
      activePromptSpecial: false,
      activePrompt14: false,
      activePrompt15: false,
      activePrompt16: false,
      activePrompt17: false,
      activePrompt18: false,
      activePrompt19: false,
      activePrompt20: false,
      activePromptDaily : false,
      activePromptWeekend : false,
      fileName: '',
      cellAutoWidth: true,
      formats: ['xlsx', 'csv', 'txt'],
      selectedFormat: 'xlsx',
      headerTitle: ['Username', 'เบอร์โทรศัพท์', 'LINE'],
      headerVal: ['topup_username', 'member_phone', 'member_line'],
      currentDataSource: ''
    }
  },
  async mounted () {
    await this.selectdate_time(this.currentWebsite)
  },
  methods: {
    async selectdate_time (from_website) {

      const { label, value } = from_website

      await axios
        .get(`reportpromotion/bonus/solo78/${this.before_datetime}/${this.after_datetime}/${value}`)
        .then(response => (this.rpbonus = response.data))
      await axios
        .get(`reportpromotion/databonus/solo78/${this.before_datetime}/${this.after_datetime}/${value}`)
        .then(response => (this.data = response.data))
      this.fileName = `Report_Bonus ${this.before_datetime} ${this.after_datetime} (${label})`

      this.currentDataSource = label
    },
    exportToExcel (sum_data, name) {
      import('@/vendor/Export2Excel').then(excel => {
        const list = sum_data

        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: `${this.fileName  } ${  name}`,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })

        this.clearFields()
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    clearFields () {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    }

  },
  computed: {
    currentWebsite () {
      return this.$store.state.currentWebsite
    }
  },
  watch: {
    currentWebsite (newWebsite, oldWebsite) {
      if (newWebsite.value !== oldWebsite.value) {
        // Put get data function here
        this.selectdate_time(this.currentWebsite)
      }
    }
  }
}

</script>

<style></style>
